export const BACKSPACE_KEY = 'Backspace'
export const ENTER_KEY = 'Enter'
export const NUMBERS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
]
export const PLUS_KEY = '+'
export const ZERO_KEY = '0'
export const NUMPAD_ARIA_LABEL = 'Numpad input'
export const NUMPAD_TEST_ID = 'numpad-input'
export const LAST_ARRAY_ELEMENT_INDEX = -1
